import(/* webpackMode: "eager" */ "/home/damir/bpm/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/damir/bpm/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/damir/bpm/node_modules/nextjs-toploader/dist/index.js");
